var MuiDialog = {
    /* put your new default props here */
    fullWidth: true,
    maxWidth: 'sm',
};
export default MuiDialog;
//# sourceMappingURL=MuiDialog.js.map